<template>
    <div class="controlItemWrapper" :class="control.className" :data-control-name="control.name">
        <div class="controlItem row" :id="control.name" v-if="labelPosition === 'left'">
            <div class="col-md-4">
                <label :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}">
                    {{control.label}}
                </label>
            </div>
            <div class="col-md-8 input-group">
                <div class="w-100">
                    <b-form-checkbox
                        type="checkbox"
                        :readonly="this.control.readonly"
                        :name="control.fieldName"
                        v-model="control.value"
                        :disabled="control.readonly"
                    />
                </div>
            </div>
        </div>
        <div class="controlItem row" :id="control.name" v-else>
            <div class="form-group col-md-12">
                <label :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}">
                    {{control.label}}
                </label>
                <div class="input-group">
                    <div class="w-100">
                        <b-form-checkbox
                            type="checkbox"
                            :readonly="this.control.readonly"
                            :name="control.fieldName"
                            v-model="control.value"
                            :disabled="control.readonly"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CheckboxControl",
        props: ['control', 'labelPosition'],
    }
</script>

<style scoped>

</style>
